import {
  Button,
  CardHeader,
  Chip,
  Grid,
  Link,
  Menu,
  Modal,
  Paper,
  Skeleton,
  TableContainer,
  TableSortLabel,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState, type FC } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import ReAssignTherapist from 'src/components/document-management/re-assign-therapist';
import SelectSuperVisor from 'src/components/document-management/select-supervisor';
import Label from 'src/components/Label';
import { Scrollbar } from 'src/components/scrollbar';
import useCurrentUser from 'src/hooks/use-current-user';
import RightIcon from 'src/icons/untitled-ui/duocolor/rightIcon';
import useEffectAfterMount from 'src/layouts/components/useEffectAfterMount';
import emptyImg from 'src/pages/therapist-dashboard/therapist-document/image-removebg-preview.png';
import { paths } from 'src/paths';
import {
  resetreAssignTherapistAction,
  resetUuidAction,
} from 'src/redux/actions/documentationAction';
import {
  getAllPatientsByAction,
  getPatientIdAction,
  resetPatientRecordAction,
  switchTherapistDisciplineAction,
} from 'src/redux/actions/patientAction';
import {
  getAllOtherDashboardDocuments,
  previewDashboardDoc,
  resetAllOtherDashboardDocuments,
} from 'src/redux/actions/therapist-dashboard-action';
import { modalStyle } from 'src/utils/common-properties';
import { checkSignPermission } from 'src/utils/signaturePermissions';
import LoaderIcon from '../../../../../src/components/LoaderImg/loader.gif';
import { DocumentIcons } from '../../dashboard-icon';
import { ActionType, documentTypes } from '../document-manegment-const';
import { MenuDateFilter } from '../menu-date-filter';
import MultiSelectWithSearch from '../table-header-multiselect-search';
import { TableHeaderMultiselect } from '../table-hearder-multiselect';
import SelectSupervisior from './SelectSupervisor';

const OtherSignatureDocument: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getDocumentRes = useSelector((state: any) => state.otherDashboardDocumentListReducer);
  const [providerId, firstName, lastName] = useCurrentUser(['providerId', 'firstName', 'lastName']);
  const { patients, patientDetails, episodeOfCare, details } = paths;

  const totalPatientRes = useSelector((state: any) => state.getAllPatientsReducer);

  const defaultSortConfig: { key: string; direction: 'asc' | 'desc' } = {
    key: 'dateOfService',
    direction: 'desc',
  };
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' }>(
    defaultSortConfig
  );
  const resetSortToDefault = () => setSortConfig(defaultSortConfig);
  // On Clear from a specific column filter, snap that column to asc sort so
  // "Sort A-Z" reflects as the active selection and the API receives asc.
  const resetSortToAsc = (key: string) => () => setSortConfig({ key, direction: 'asc' });

  //clock in modal
  const [selectedDocument, setSelectedDocument] = useState<any>('');

  const previewDocument = (formId: any) => {
    dispatch(previewDashboardDoc(formId));
    navigate('/dashboard/doc');
  };

  useEffect(() => {
    if (providerId) {
      dispatch(resetAllOtherDashboardDocuments());
      setSelectedTherapist([
        {
          label: `${firstName} ${lastName}`,
          value: providerId,
        },
      ]);
    }
  }, [providerId]);

  const goToEoc = (document: any) => {
    dispatch(getPatientIdAction(document?.patientId));
    dispatch(switchTherapistDisciplineAction(''));
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
      state: {
        episodeOfCareId: document?.episodeOfCareId,
        getPatientId: document?.patientId,
      },
    });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [getCurrentItem, setGetCurrentItem] = useState<any>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
    setGetCurrentItem(null);
  };

  const listOfTherapistAvailability = useSelector(
    (state: any) => state.getListOfTherapistAvaiReducer
  );
  const reAssigneResponse = useSelector((state: any) => state.reAssigntherapistReducer);
  const callSubmitEventReducer = useSelector((state: any) => state.callSubmitEventReducer);
  const [selectedTherapist, setSelectedTherapist] = useState<any>([]);

  const [selectedDocumentType, setSelectedDocumentType] = useState<any>([]);
  const [selectedAction, setSelectedAction] = useState<any>([]);
  const [selectedDisciples] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState<any>([]);
  const [selectedStatus] = useState<any>([]);
  const [selectedDueDate, setSelectedDueDate] = useState<any>({
    startDate: '',
    endDate: '',
  });

  const getListOfValues = (items: any) => {
    return items?.map((therapist: any) => therapist?.value);
  };

  const getAllDocumentApiCall = (page: number) => {
    dispatch(
      getAllOtherDashboardDocuments({
        param: {
          page: page,
          therapistIds: selectedTherapist?.length
            ? getListOfValues(selectedTherapist)
            : getListOfValues(getTherapistList),
          pageSize: 20,
          documentTypes: selectedDocumentType?.length
            ? getListOfValues(selectedDocumentType)
            : null,
          types: selectedDisciples?.length ? getListOfValues(selectedDisciples) : null,
          dueStatus: selectedStatus?.length ? getListOfValues(selectedStatus) : null,
          startDate: selectedDueDate?.startDate
            ? moment(selectedDueDate?.startDate).format('YYYY-MM-DD')
            : null,
          endDate: selectedDueDate?.endDate
            ? moment(selectedDueDate?.endDate).format('YYYY-MM-DD')
            : null,
          patientIds: selectedPatient?.length ? getListOfValues(selectedPatient) : null,
          sortBy: sortConfig?.key,
          sortDirection: sortConfig?.direction,
          isPhysicianSignatureCompleted: selectedAction?.some(
            (res: any) => res?.value === 'COMPLETED'
          ),
          getUnassignedDocsDue: selectedAction?.some((res: any) => res?.value === 'UNASSIGNED'),
          isPhysicianSignaturePending: selectedAction?.some((res: any) => res?.value === 'PENDING'),
          isPhysicianSignatureNotRequired: selectedAction?.some(
            (res: any) => res?.value === 'NOT_REQUIRED'
          ),
        },
        params: {
          requestedDocType: 'OTHER_PENDING_DOC',
        },
      })
    );
  };

  useEffectAfterMount(() => {
    // if (selectedTherapist?.length) {
    dispatch(resetAllOtherDashboardDocuments());
    getAllDocumentApiCall(0);
    // }
  }, [
    selectedDocumentType,
    selectedStatus,
    selectedDueDate,
    selectedPatient,
    selectedTherapist,
    selectedDisciples,
    sortConfig,
    selectedAction,
  ]);

  const getTherapistList = useMemo(() => {
    const mappedTherapists = listOfTherapistAvailability?.response?.data?.map((res: any) => {
      return {
        label:
          res?.uuid === providerId
            ? `${res?.lastName}, ${res?.firstName} (Me)`
            : `${res?.lastName}, ${res?.firstName}`,
        value: res?.uuid,
      };
    });

    return mappedTherapists?.sort((a: any, b: any) => {
      return a?.label.localeCompare(b?.label);
      // if (a?.value === providerId) return -1;
      // if (b?.value === providerId) return 1;
      // return 0;
    });
  }, [listOfTherapistAvailability, providerId]);

  const [pageNo, setPageNo] = useState(0);

  useEffect(() => {
    dispatch(resetPatientRecordAction());
    dispatch(
      getAllPatientsByAction({
        data: {
          searchString: '',
        },
        params: {
          page: 0,
          pageSize: 20,
          active: true,
        },
      })
    );
    dispatch(resetUuidAction());
  }, []);
  const getAllPatientList = useMemo(() => {
    return totalPatientRes?.totalPatients.map((res: any) => {
      return {
        label: `${res?.lastName}, ${res?.firstName}`,
        value: res?.uuid,
      };
    });
  }, [totalPatientRes]);

  const handleSort = (key: string) => {
    const isAsc = sortConfig.key === key && sortConfig.direction === 'asc';
    const direction = isAsc ? 'desc' : 'asc';
    setSortConfig({ key, direction });
  };

  const handleSortMultiselect = useCallback((label: any, direction: any) => {
    if (label === 'Therapist') return setSortConfig({ key: 'therapistName', direction });
    if (label === 'Document Type') return setSortConfig({ key: 'documentType', direction });
    if (label === 'Discipline') return setSortConfig({ key: 'discipline', direction });
    if (label === 'Status') return setSortConfig({ key: 'dueStatus', direction });
    if (label === 'PatientName') return setSortConfig({ key: 'patientName', direction });
  }, []);

  const userProviderUuid = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.providerId
  );
  const providerInfo = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );
  const getSignatureAccess = useSelector((state: any) => state.getSignatureAccessReducer);

  const [openReassignTherapist, setOpenReassignTherapist] = useState(false);
  const [role, selectRole] = useState('');
  const openReassignTherapistModal = (document: any, role: string) => {
    setSelectedDocument(document);
    selectRole(role);
    setOpenReassignTherapist(true);
  };
  const closeReassignTherapistModal = () => {
    setOpenReassignTherapist(false);
  };
  const checkWhosSignNeed = (document: any) => {
    if (
      document?.documentType.toLowerCase().includes('evaluation') ||
      document?.documentType.toLowerCase().includes('recertification')
    ) {
      return 'Physician';
    } else {
      return 'Supervisor';
    }
  };

  const [triggerSelectSupervisor, setTriggerSupervisor] = useState(false);

  const openSelectSupervisorModal = (document: any, role: string) => {
    setSelectedDocument(document);
    selectRole(role);
    setTriggerSupervisor(true);
  };

  const closeSupervisorModal = () => {
    setTriggerSupervisor(false);
  };

  useEffect(() => {
    if (!reAssigneResponse.isReAssign && reAssigneResponse.response === null) return;
    dispatch(resetAllOtherDashboardDocuments());
    getAllDocumentApiCall(0);
    dispatch(resetreAssignTherapistAction());
  }, [reAssigneResponse]);

  useEffect(() => {
    if (!callSubmitEventReducer?.isEventCalled) return;
    dispatch(resetAllOtherDashboardDocuments());
    getAllDocumentApiCall(0);
  }, [callSubmitEventReducer]);

  return (
    <>
      <Card>
        <CardHeader
          title={
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h6">Other Signature Pending</Typography>
                  {getDocumentRes?.loading ? (
                    <Box sx={{ width: 100, ml: 3 }}>
                      <Typography
                        width={'100%'}
                        variant="h4"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                    </Box>
                  ) : (
                    <Chip
                      label={`${
                        getDocumentRes?.response?.data?.totalElements
                          ? getDocumentRes?.response?.data?.totalElements
                          : '0'
                      } Document`}
                      variant="outlined"
                      sx={{ marginLeft: '10px' }}
                    />
                  )}
                </Box>
              </Box>
            </>
          }
        />

        <Scrollbar>
          <>
            <Stack gap="1rem">
              <TableContainer
                component={Paper}
                sx={{ height: 700 }}
              >
                <InfiniteScroll
                  dataLength={getDocumentRes?.totalFacility?.length}
                  next={() => {
                    getAllDocumentApiCall(getDocumentRes?.pageNumber);
                  }}
                  style={{
                    overflow: 'scroll',
                    height: 700,
                  }}
                  height={800}
                  hasMore={
                    getDocumentRes?.response?.data?.totalElements !==
                    getDocumentRes?.totalFacility?.length
                  }
                  loader={
                    getDocumentRes?.loading ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: 250,
                          width: '100%',
                          // marginTop: ,
                        }}
                      >
                        <img
                          src={LoaderIcon}
                          alt="loader.."
                        />
                      </div>
                    ) : !getDocumentRes?.isGetDocuments && getDocumentRes?.response !== null ? (
                      <Box>
                        <img
                          src={emptyImg}
                          alt="loader"
                          style={{
                            width: 720,
                            height: 300,
                            margin: 'auto',
                            alignItems: 'center',
                            alignContent: 'center',
                            marginTop: 100,
                            display: 'block',
                          }}
                        />

                        <Typography
                          color={'text.secondary'}
                          variant="h5"
                          fontWeight={'200'}
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          Something went wrong
                        </Typography>
                      </Box>
                    ) : null
                  }
                  endMessage={
                    <Box
                      textAlign="center"
                      p={3}
                    >
                      {getDocumentRes?.totalFacility?.length === 0 ? (
                        <Box>
                          <img
                            src={emptyImg}
                            alt="loader"
                            style={{
                              width: 720,
                              height: 300,
                              margin: 'auto',
                              alignItems: 'center',
                              alignContent: 'center',
                              marginTop: 100,
                              display: 'block',
                            }}
                          />

                          <Typography
                            color={'text.secondary'}
                            variant="h5"
                            fontWeight={'200'}
                          >
                            No results found
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>
                  }
                >
                  <Table
                    stickyHeader
                    sx={{ minWidth: 700 }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'patientName'}
                            direction={
                              sortConfig.key === 'patientName' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('patientName')}
                          >
                            Patient
                          </TableSortLabel>
                          <MultiSelectWithSearch
                            options={getAllPatientList}
                            pageNo={pageNo}
                            setPageNo={setPageNo}
                            handleSortMultiselect={handleSortMultiselect}
                            setAppliedValues={setSelectedPatient}
                            appliedValues={selectedPatient}
                            sortConfig={sortConfig}
                            onClearAll={resetSortToAsc('patientName')}
                          />
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'documentType'}
                            direction={
                              sortConfig.key === 'documentType' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('documentType')}
                          >
                            Document Type
                          </TableSortLabel>
                          <TableHeaderMultiselect
                            label="Document Type"
                            sortConfig={sortConfig}
                            appliedValues={selectedDocumentType}
                            setAppliedValues={setSelectedDocumentType}
                            options={documentTypes}
                            handleSortMultiselect={handleSortMultiselect}
                            onClearAll={resetSortToAsc('documentType')}
                          />
                        </TableCell>

                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'dateOfService'}
                            direction={
                              sortConfig.key === 'dateOfService' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('dateOfService')}
                          >
                            Date of Service
                          </TableSortLabel>
                          <MenuDateFilter
                            label="Date of Service"
                            setSelectedDueDate={setSelectedDueDate}
                            selectedDueDate={selectedDueDate}
                          />
                        </TableCell>

                        <TableCell>
                          <TableSortLabel
                            active={sortConfig.key === 'therapistName'}
                            direction={
                              sortConfig.key === 'therapistName' ? sortConfig.direction : 'asc'
                            }
                            onClick={() => handleSort('therapistName')}
                          >
                            Therapist Signature
                          </TableSortLabel>
                          <TableHeaderMultiselect
                            label="Therapist"
                            appliedValues={selectedTherapist}
                            sortConfig={sortConfig}
                            setAppliedValues={setSelectedTherapist}
                            options={getTherapistList}
                            handleSortMultiselect={handleSortMultiselect}
                            onClearAll={resetSortToAsc('therapistName')}
                          />
                        </TableCell>

                        <TableCell>
                          <TableSortLabel>Supervisor Signature</TableSortLabel>
                        </TableCell>

                        <TableCell>
                          <TableSortLabel>Physician Signature</TableSortLabel>
                        </TableCell>

                        <TableCell>
                          Action
                          <TableHeaderMultiselect
                            label="Action"
                            sortConfig={sortConfig}
                            appliedValues={selectedAction}
                            setAppliedValues={setSelectedAction}
                            options={ActionType}
                            handleSortMultiselect={handleSortMultiselect}
                            onClearAll={resetSortToDefault}
                          />
                        </TableCell>
                        <TableCell align="right"></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody sx={{ height: 1 }}>
                      {getDocumentRes?.totalFacility?.map((document: any, index: any) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>
                              <Box>
                                <Typography variant="subtitle2">{document?.patientName}</Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Stack
                                alignItems="center"
                                direction="row"
                                spacing={1}
                              >
                                <Grid
                                  container
                                  sx={{ alignItems: 'center' }}
                                >
                                  <Box sx={{ marginRight: '4px', marginTop: '7px' }}>
                                    <DocumentIcons
                                      iconType={document?.formType?.split('_')?.[0]?.toLowerCase()}
                                    />
                                  </Box>

                                  <Box sx={{ display: 'flex' }}>
                                    <Typography variant="subtitle2">
                                      {document?.documentType}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Stack>
                            </TableCell>
                            <TableCell>
                              {' '}
                              <Typography variant="subtitle2">
                                {' '}
                                {document?.dateOfService}
                              </Typography>
                            </TableCell>
                            <TableCell
                              sx={{
                                cursor: checkSignPermission(document).value ? 'pointer' : 'default',
                              }}
                            >
                              <Typography
                                variant="caption"
                                display={'inline'}
                              >
                                {document.signedBy ? (
                                  document.signedBy[0]
                                ) : (
                                  <Link onClick={() => openReassignTherapistModal(document, role)}>
                                    <Typography
                                      variant="body2"
                                      sx={{ cursor: 'pointer' }}
                                    >
                                      Re-assign Therapist
                                    </Typography>
                                  </Link>
                                )}
                              </Typography>
                              {checkSignPermission(document).value ? (
                                <Label
                                  backgroundColor="rgba(17, 25, 39, 0.08)"
                                  color="#6C737F"
                                  text="Pending"
                                />
                              ) : checkSignPermission(document).label === 'Signed' ? (
                                <Label
                                  backgroundColor="#15B79E1F"
                                  color="#107569"
                                  text="Signed"
                                />
                              ) : (
                                <Label
                                  backgroundColor="rgba(17, 25, 39, 0.08)"
                                  color="#6C737F"
                                  text="Pending"
                                />
                              )}
                              {document.signedBy &&
                                !document?.isReassigned &&
                                document?.status !== 'COMPLETED' &&
                                document?.formType !== 'DAILY_SOAP_NOTE' && (
                                  <Link onClick={() => openReassignTherapistModal(document, role)}>
                                    <Typography
                                      variant="body2"
                                      sx={{ cursor: 'pointer' }}
                                    >
                                      Re-assign Therapist
                                    </Typography>
                                  </Link>
                                )}
                            </TableCell>
                            <TableCell>
                              <SelectSupervisior
                                role={'Supervisor'}
                                document={document}
                                openSelectSupervisorModal={openSelectSupervisorModal}
                                who={'supervisor'}
                              />
                            </TableCell>
                            <TableCell>
                              <SelectSupervisior
                                role={'Physician'}
                                document={document}
                                openSelectSupervisorModal={openSelectSupervisorModal}
                                who={'physician'}
                              />
                            </TableCell>
                            <TableCell align="left">
                              <Button
                                onClick={() => previewDocument(document)}
                                size="small"
                                sx={{
                                  color: ' #6366F1',
                                  fontWeight: 500,
                                  fontSize: '14px',
                                }}
                              >
                                View
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </InfiniteScroll>
              </TableContainer>
            </Stack>
          </>
        </Scrollbar>
      </Card>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onMouseLeave={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box onMouseLeave={handleClose}>
          <Typography>
            <Button
              onClick={() => goToEoc(getCurrentItem)}
              endIcon={<RightIcon />}
            >
              Go to Episode of Care
            </Button>
          </Typography>
        </Box>
      </Menu>

      {/* For selecting a supervisor */}
      <Modal
        style={modalStyle}
        open={triggerSelectSupervisor}
        onClose={closeSupervisorModal}
      >
        <div>
          <SelectSuperVisor
            activeTab={providerInfo?.discipline}
            close={closeSupervisorModal}
            selectedDocument={selectedDocument}
            role={role}
            source="OTHER_SECTION"
          />
        </div>
      </Modal>

      {/* For re-assign therapist */}
      <Modal
        style={modalStyle}
        open={openReassignTherapist}
        onClose={closeReassignTherapistModal}
      >
        <div>
          <ReAssignTherapist
            activeTab={selectedDocument?.type || providerInfo?.discipline}
            close={closeReassignTherapistModal}
            selectedDocument={selectedDocument}
            role="Therapist"
          />
        </div>
      </Modal>
    </>
  );
};

export default OtherSignatureDocument;
